<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="zeroStateRows"
      styleClass="vgt-table striped"
      row-style-class="blur-row"
      style="width: 100%;"
    >
      <template slot="table-row" slot-scope="zeroStateRows">
        <template v-if="zeroStateRows.column.field === 'details'">
          <span class="view-details">View details</span>
        </template>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'InvoicesZeroState',
  components: {
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: 'Invoice Date',
          field: 'invoiceDate',
          sortable: false,
          width: '15%'
        },
        {
          label: 'Invoice #',
          field: 'invoiceNumber',
          sortable: false,
          width: '15%'
        },
        {
          label: 'Title / Description',
          field: 'title',
          sortable: false,
          width: '30%'
        },
        {
          label: 'Amount',
          field: 'amount',
          sortable: false,
          width: '15%'
        },
        {
          label: 'Status',
          field: 'status',
          sortable: false,
          width: '15%'
        },
        {
          label: 'Details',
          field: 'details',
          sortable: false,
          width: '10%'
        }
      ],
      zeroStateRows: [
        {
          invoiceDate: 'MM/DD/YYYY',
          invoiceNumber: '#########',
          title: 'Your Monthly Subscription - Pro Plan',
          amount: '$XXX.XX',
          status: 'Paid',
          details: ''
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
h5 {
  margin: 3rem;
}

.brand-icon {
  height: 50px;
}

.view-details {
  font-weight: 400;
  text-decoration: underline;
}
</style>
